import React, {useState} from 'react';
import {Button, LinearProgress, Typography} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import * as XLSX from 'xlsx';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { RouteNames } from '../../../router/consts';
import { useDispatch } from 'react-redux';
import { setRowsForTableConstructor } from '../../../redux/reducers/act-reducer';
import { mutateStackUpload, stackFromUpload } from '../../../utils/stackField';
import { addDocumentDataColumn, addDocumentDataStroke, idColumn } from '../../../utils/addDocument';


export const AddDocumentTableConstructor = ({
    setValues,
    setColumns,
    setFieldValue,
    handleClose,
    setFileName,
    offenseWindow,
    setErrorColumn,
    setSuccessColumn,
}) => {

    const [loading, setLoading] = useState(false)
    const [chosenFile, setChoseFile] = useState(null)

    const location = useLocation()

    const errorUpload = () => {
        setErrorColumn(true)
        setLoading(false)
    }

    const successUploadAct = (dataStroke, goodNameFile) => {
        setValues(dataStroke);
        setFileName(goodNameFile);
        setLoading(false);
        setSuccessColumn(true);
        handleClose();
    }

    const successUploadActAdmin = (dataStroke, dataHead, columns, goodNameFile) => {
        setFieldValue('content.adminRows', dataStroke)
        setFieldValue('content.adminColumns', columns)
        setFieldValue('content.adminHead', dataHead)
        setFieldValue('content.fileName', goodNameFile)

        setValues(dataStroke)
        setColumns(columns)
        setLoading(false)
        setSuccessColumn(true)
    }

            
    const handleUploadButtonClick = async () => {
        setLoading(true)
        
        const reader = new FileReader();
        reader.onload = (evt) => { 
          
            const bstr = evt.target.result;
            const wb = XLSX.read(bstr, {type:'binary'});
            const wsname = wb.SheetNames[0];
            const ws = wb.Sheets[wsname];
            /* Convert array of arrays */
            const data = XLSX.utils.sheet_to_json(ws, {header:1});
            
            
            const dataHead = data[0]
            const dataRow = [...data]
            

            dataRow.splice(0, 1)
            
            if (dataHead.length !== offenseWindow.length) {
                errorUpload()
            } 
                else 
            {   
                const stack = stackFromUpload()
                
                const filledStack = mutateStackUpload(offenseWindow, stack)

                let dataStroke = addDocumentDataStroke(dataRow, offenseWindow, dataHead, filledStack)
                dataStroke = dataStroke.map((obj, i) => ({ ...obj, id: i + 1 }));

                const idColumnFirst = idColumn()
                
                

                const dataColumns = addDocumentDataColumn(offenseWindow)
                

                const columns = [...idColumnFirst, ...dataColumns]
                

                const goodNameFile = chosenFile.name.slice(0, -5)
          
                if (location.pathname.includes(RouteNames.CREATE_ACT)) {
                    successUploadAct(dataStroke, goodNameFile)
                } else {
                    successUploadActAdmin(dataStroke, dataHead, columns, goodNameFile)
                }
            }
        };

        
        reader.readAsBinaryString(chosenFile); 
        setLoading(false)
    }

    const onFileChange = (event) => {
        setChoseFile(event.target.files[0])
    }

    return (
        <div style={{border: '2px solid #000', marginTop: '50px', padding: '10px'}}>
                <Grid container direction={'column'} spacing={2}>
                    <Grid item>
                        <input
                            color="primary"
                            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                            type="file"
                            onChange={onFileChange}
                            id="icon-button-file-1"
                            style={{display: 'none'}}
                        />
                        <label htmlFor="icon-button-file-1">
                            <Button
                                variant="contained"
                                size="small"
                                component="span"
                                color="primary"
                                disabled={loading}
                            >
                                Выбрать файл
                            </Button>
                        </label>
                    </Grid>
                    <Grid item>
                        <Typography>
                            {chosenFile ? `Выбран файл "${chosenFile.name}"` : 'Выберите файл для загрузки'}
                        </Typography>
                    </Grid>
                    <Grid item>
                        <LinearProgress hidden={!loading}/>
                    </Grid>
                </Grid>
                <Grid container justifyContent={'flex-end'}>
                    <Grid item>
                        <Button onClick={handleUploadButtonClick} disabled={!Boolean(chosenFile)}>
                            Загрузить
                        </Button>
                    </Grid>
                </Grid>
        </div>
    );
};


